import { render, staticRenderFns } from "./PelleTab.vue?vue&type=template&id=8913c842&scoped=true&"
import script from "./PelleTab.vue?vue&type=script&lang=js&"
export * from "./PelleTab.vue?vue&type=script&lang=js&"
import style0 from "./PelleTab.vue?vue&type=style&index=0&id=8913c842&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8913c842",
  null
  
)

export default component.exports